import { Component, Input, OnInit } from '@angular/core';
import { MbBaseComponent, __ } from '@montblancsimpl/core';
import { finalize, map } from 'rxjs/operators';
import { NewsCarouselService } from './news-carousel.service';
import { NewsDto } from '@app/news/@shared/models/NewsDto';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MbCarouselComponent } from '../carousel/carousel.component';
import { MbCarouselItemDirective } from '../carousel/carousel-item.directive';
import { RouterModule } from '@angular/router';

const visibilityKey = 'visibility_78gf9ug273980hw9pos';

const newsKey = 'news_gzasduhagzs86dta7gsiubo';

@Component({
    selector: 'dis-news-carousel',
    templateUrl: './news-carousel.component.html',
    styleUrls: ['./news-carousel.component.scss'],
    imports: [
        CommonModule,
        MbCarouselComponent,
        MbCarouselItemDirective,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        RouterModule,
    ]
})
export class NewsCarouselComponent extends MbBaseComponent implements OnInit {
  newsArray: NewsDto[] = [];

  @Input() isVisible: boolean = true;

  constructor(private newsCarouselService: NewsCarouselService) {
    super();

    const visibility = JSON.parse(localStorage.getItem(visibilityKey));

    if (!__.IsNullOrUndefined(visibility)) {
      this.isVisible = visibility;
    }
  }

  ngOnInit() {
    this.isLoading = true;

    super.addSubscription(
      this.newsCarouselService
        .get(true)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
        )
        .subscribe({
          next: (news: NewsDto[]) => {
            this.newsArray = news;

            if (this.isVisible === false) {
              this.isVisible = this.anyNewsUnseen(this.newsArray);
            }

            localStorage.setItem(newsKey, JSON.stringify(this.newsArray.map((q) => q.id)));
          },
        }),
    );
  }

  toggle(): void {
    this.isVisible = !this.isVisible;

    localStorage.setItem(visibilityKey, JSON.stringify(this.isVisible));
  }

  private anyNewsUnseen(news: NewsDto[]): boolean {
    const newsIds = JSON.parse(localStorage.getItem(newsKey)) as string[];

    return !news.every((a) => newsIds.some((p) => p === a.id));
  }
}
